import { render } from "./ProblemsAcknowleged.vue?vue&type=template&id=4079d17c&scoped=true"
import script from "./ProblemsAcknowleged.vue?vue&type=script&lang=js"
export * from "./ProblemsAcknowleged.vue?vue&type=script&lang=js"

import "./ProblemsAcknowleged.vue?vue&type=style&index=0&id=4079d17c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4079d17c"]])

export default __exports__